<template>
  <v-card
    dark
    class="primary darken-1"
    height="327"
    :width="width"
    :min-width="minWidth"
    :style="useSoil ? 'border-radius: 5px; overflow-y: auto' : ''"
  >
    <v-expand-transition>
      <div
        v-if="useSoil"
        class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal"
      >
        <v-card-text class="secondary--text text--lighten-1 text-justify">
          <v-row>
            <v-col cols="6">
              <v-icon large color="secondary lighten-1" @click="toggleUseSoil"
                >mdi-arrow-left-circle</v-icon
              >
            </v-col>
            <v-spacer />
            <v-col cols="6" align-self="end" align="end">
              <v-icon large color="secondary lighten-1">$useSoil</v-icon>
            </v-col>
          </v-row>
          <br />
          {{ useSoilText }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <div v-if="!useSoil">
      <v-card-subtitle class="white--text text--white">
        <span class="textDate"
          ><v-icon small>restore</v-icon> atualizado em</span
        ><br />
        <span class="textDate" v-if="indicator">{{
          indicator.params.data_dado
        }}</span>
        <span class="textDate" v-else>dd/mm/aaaa</span>
      </v-card-subtitle>
      <v-card-title>
        <v-icon class="ml-n1" color="secondary lighten-1" large>
          $useSoil
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="white--text text--white">
        <strong class="textTitle">Uso do solo</strong>
        <v-tooltip right color="#1A232F">
          <template v-slot:activator="{on, attrs}">
            <v-icon
              style="z-index: 999"
              class="ml-1"
              color="secondary lighten-1"
              v-bind="attrs"
              v-on="on"
              @click="toggleUseSoil"
            >
              help_outline
            </v-icon>
          </template>
          <span>Clique para informações</span>
        </v-tooltip>
      </v-card-subtitle>
      <v-card-text class="white--text text--white">
        <v-row dense>
          <v-col cols="12">
            <card-use-soil-chart
              class="mt-n13"
              :values="location ? usoSolo : indicator.vals"
            ></card-use-soil-chart>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import CardUseSoilChart from '@/components/indicators/IndicatorsCardsItems/CardUseSoilChart';
export default {
  name: 'CardUseSoil',
  props: {
    minWidth: {
      required: false,
    },
    width: {
      required: false,
    },
    location: {
      required: true,
    },
    indicator: {
      required: true,
    },
    usoSolo: {
      required: true,
    },
  },
  components: {CardUseSoilChart},
  data() {
    return {
      useSoil: false,
      useSoilText:
        'Como indicação prévia, será adotado mapa de uso e cobertura da terra atualizado (gerado com imagens adquiridas em 2021), produzido pela equipe do Simepar com a colaboração do programa de pós-graduação da UFPR (departamento de Geomática). Para esta classificação do uso e cobertura da terra fez-se uso de métodos de Inteligência Artificial, mais especificamente, foi usado o método de classificação supervisionada de Machine Learning (ML) conhecido como Random Forest (RF).',
    };
  },
  methods: {
    toggleUseSoil() {
      this.useSoil = !this.useSoil;
    },
  },
};
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}
/* width */
::-webkit-scrollbar {
  width: 7px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: darkgrey;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>
